import { MuiThemeProvider } from '@inbody/core';
import { AuthProvider } from '@inbody/keycloak';

import './App.css';
import { initializeDate } from './shared/lib/dayjs';
import { DayjsLocalization } from './shared/lib/dayjs/provider';
import { CustomQueryProvider } from './shared/lib/react-query';
import { BrowserRouter } from './shared/lib/react-router';
import { typographyCustomTheme } from './shared/theme/muiTypographyCustomTheme';

import '@/shared/lib/i18n';

initializeDate();
function App() {
  return (
    <>
      <MuiThemeProvider
        customThemeOptions={{ typography: typographyCustomTheme }}
      >
        <CustomQueryProvider>
          <AuthProvider
            config={{
              clientId: 'indrive',
              url: 'https://keycloak.weareinbody.com',
            }}
          >
            <DayjsLocalization>
              <BrowserRouter />
            </DayjsLocalization>
          </AuthProvider>
        </CustomQueryProvider>
      </MuiThemeProvider>
    </>
  );
}

export default App;
